export const commentsData = [
	{
		capture_id: 8621399,
		comment_type: 'Doubt',
		comment_text: 'Hotspots are not that clear',
		resolved: false,
		raised_by: 'lucy.colley',
		datetime: '2025-07-15 14:34:32',
		resolved_by: null,
		resolved_comment: null,
		resolved_datetime: null
	},
	{
		capture_id: 8621399,
		comment_type: 'Comment',
		comment_text: 'Yes they are lol',
		resolved: true,
		raised_by: 'george.begkas',
		datetime: '2025-07-25 09:18:32',
		resolved_by: 'guy.cook',
		resolved_comment: 'Agree with George',
		resolved_datetime: '2025-07-28 11:30:01'
	}
];

export const commentTypes = ['Doubt', 'Concern', 'Error', 'Comment'];

export const unresolvedComments = [
	{
		comment_id: 1050,
		capture_id: 8621399,
		comment_type: 'Doubt',
		comment_text: 'Lorem ipsum dolor sit amet.',
		resolved: false,
		raised_by: 'alex.martin',
		datetime: '2025-07-15 14:34:32',
		resolved_by: null,
		resolved_comment: null,
		resolved_datetime: null
	},
	{
		comment_id: 1051,
		capture_id: 7374253,
		comment_type: 'Comment',
		comment_text: 'Consectetur adipiscing elit.',
		resolved: true,
		raised_by: 'sophia.williams',
		datetime: '2025-06-21 09:12:47',
		resolved_by: 'alex.martin',
		resolved_comment: 'Sed do eiusmod tempor incididunt',
		resolved_datetime: '2025-06-28 11:18:47'
	},
	{
		comment_id: 1052,
		capture_id: 7373948,
		comment_type: 'Concern',
		comment_text: 'Sed do eiusmod tempor incididunt ut labore.',
		resolved: false,
		raised_by: 'james.anderson',
		datetime: '2025-05-03 18:45:22',
		resolved_by: null,
		resolved_comment: null,
		resolved_datetime: null
	},
	{
		comment_id: 1053,
		capture_id: 9148271,
		comment_type: 'Error',
		comment_text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
		resolved: false,
		raised_by: 'emma.johnson',
		datetime: '2025-07-29 16:12:04',
		resolved_by: null,
		resolved_comment: null,
		resolved_datetime: null
	},
	{
		comment_id: 1060,
		capture_id: 6524910,
		comment_type: 'Correction',
		comment_text:
			'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
		resolved: true,
		raised_by: 'liam.smith',
		datetime: '2025-05-18 10:22:59',
		resolved_by: 'sophia.williams',
		resolved_comment:
			'Ut enim ad minim veniam, quis nostrud exercitation ullamco.',
		resolved_datetime: '2025-05-19 08:14:33'
	},
	{
		comment_id: 1065,
		capture_id: 7812634,
		comment_type: 'Concern',
		comment_text:
			'Duis aute irure dolor in reprehenderit in voluptate velit esse.',
		resolved: true,
		raised_by: 'olivia.brown',
		datetime: '2025-06-03 13:09:41',
		resolved_by: 'james.anderson',
		resolved_comment: 'Cillum dolore eu fugiat nulla pariatur.',
		resolved_datetime: '2025-06-05 09:45:27'
	},
	{
		comment_id: 1071,
		capture_id: 8921045,
		comment_type: 'Doubt',
		comment_text: 'Excepteur sint occaecat cupidatat non proident.',
		resolved: false,
		raised_by: 'daniel.thomas',
		datetime: '2025-07-11 20:33:16',
		resolved_by: null,
		resolved_comment: null,
		resolved_datetime: null
	},
	{
		comment_id: 1083,
		capture_id: 7238491,
		comment_type: 'Comment',
		comment_text:
			'Sunt in culpa qui officia deserunt mollit anim id est laborum.',
		resolved: true,
		raised_by: 'mia.davis',
		datetime: '2025-06-12 08:44:55',
		resolved_by: 'liam.smith',
		resolved_comment:
			'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.',
		resolved_datetime: '2025-06-14 12:21:18'
	},
	{
		comment_id: 1023,
		capture_id: 8471930,
		comment_type: 'Error',
		comment_text: 'Aliquam tincidunt mauris eu risus.',
		resolved: false,
		raised_by: 'ethan.miller',
		datetime: '2025-05-27 15:55:42',
		resolved_by: null,
		resolved_comment: null,
		resolved_datetime: null
	},
	{
		comment_id: 1013,
		capture_id: 9351748,
		comment_type: 'Concern',
		comment_text: 'Vestibulum auctor dapibus neque.',
		resolved: true,
		raised_by: 'isabella.garcia',
		datetime: '2025-07-01 11:09:03',
		resolved_by: 'olivia.brown',
		resolved_comment: 'Morbi in sem quis dui placerat ornare.',
		resolved_datetime: '2025-07-02 17:16:09'
	},
	{
		comment_id: 1045,
		capture_id: 6182940,
		comment_type: 'Correction',
		comment_text: 'Praesent dapibus, neque id cursus faucibus.',
		resolved: false,
		raised_by: 'noah.jones',
		datetime: '2025-06-17 14:27:36',
		resolved_by: null,
		resolved_comment: null,
		resolved_datetime: null
	},
	{
		comment_id: 1037,
		capture_id: 7629183,
		comment_type: 'Doubt',
		comment_text: 'Aenean commodo ligula eget dolor.',
		resolved: true,
		raised_by: 'ava.martinez',
		datetime: '2025-05-09 09:22:47',
		resolved_by: 'emma.johnson',
		resolved_comment:
			'Aenean massa. Cum sociis natoque penatibus et magnis dis.',
		resolved_datetime: '2025-05-11 10:48:02'
	},
	{
		comment_id: 1160,
		capture_id: 8592037,
		comment_type: 'Comment',
		comment_text:
			'Donec quam felis, ultricies nec, pellentesque eu, pretium quis.',
		resolved: false,
		raised_by: 'william.rodriguez',
		datetime: '2025-07-18 19:03:14',
		resolved_by: null,
		resolved_comment: null,
		resolved_datetime: null
	}
];
